import { createAction } from '../../utils/createAction';
import { createApiActions } from '../../utils/createApiActions';

import { PROJECTS_GET_BY_USER, PROJECTS_SET_LIST } from './remote.types';

export const getProjectsByUser = createApiActions(PROJECTS_GET_BY_USER);

export const setListOfRemoteProjects = createAction(PROJECTS_SET_LIST);
